import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import DetailPersonsSection from "@/components/detail/DetailPersonsSection";
import Section from "@/components/helpers/Section/Section";

import { useGetContentDetailPage } from "@/hooks/api/content.hooks";

const DetailActorsPage = (): JSX.Element => {
  const { t } = useTranslation();
  const { id } = useParams() as { id: string };
  const { data } = useGetContentDetailPage(+id);

  if (!data) return <></>;

  const content = data.content;

  return (
    <>
      <Section title={t("actors-title")} className={"mt-5 [&>h2]:text-3xl"}>
        <div className={"mt-8 space-y-6"}>
          <DetailPersonsSection title={t("actors")} persons={content.actors} />
          <DetailPersonsSection title={t("directors")} persons={content.directors} />
          <DetailPersonsSection title={t("producers")} persons={content.producers} />
        </div>
      </Section>
      {/* group/actors px-8 py-6 max-lg:p-4 */}
    </>
  );
};

export default DetailActorsPage;
